const attribute = {
    'tree-1': {
        width: 543, height: 698
    },
    'tree-2': {
        width: 596, height: 680
    },
    'tree-3': {
        width: 698, height: 677
    },
    'tree-4': {
        width: 580, height: 671
    },
    'tree-5': {
        width: 701, height: 685
    },
    'tree-6': {
        width: 630, height: 647
    },
    'dirt-1': {
        width: 340, height: 167
    },
    'dirt-2': {
        width: 402, height: 132
    },
    'dirt-3': {
        width: 212, height: 132
    },
    'dirt-4': {
        width: 276, height: 68
    },
    'dirt-5': {
        width: 142, height: 76
    },
    'cloud-1': {
        width: 835, height: 112
    },
    'cloud-2': {
        width: 572, height: 80
    },
    'cloud-3': {
        width: 778, height: 106
    },
    

}

export default attribute;